module.exports = __webpack_public_path__ + "static/media/imageOnlyLogo.245d6b0b.svg";